import React from 'react';

/**
 * Icono del rediseño: Material Symbols Rounded (ligadura por nombre).
 * La fuente la carga AppFonts con display=block, así que nunca se ve el nombre
 * del icono en crudo mientras carga.
 *
 *   <Sym name="insights" size={21} />
 */
const Sym = ({ name, size = 20, className = '', style, ...rest }) => (
  <span
    className={`msym ${className}`.trim()}
    style={{ fontSize: size, ...style }}
    aria-hidden="true"
    {...rest}
  >
    {name}
  </span>
);

export default Sym;
